import { lazy } from 'react'
import { type RouteProps } from 'react-router-dom'

export type RoutesProps = {
  path: RouteProps['path']
  name: string
  element: RouteProps['element']
  exact?: boolean
}

// Import the actual pages that exist in this project
const Skincare = lazy(() => import('../index'))
const Services = lazy(() => import('../pages/Services'))
const ServiceDetails = lazy(() => import('../pages/ServiceDetails'))
const Contact = lazy(() => import('../pages/Contact'))
const About = lazy(() => import('../pages/About'))
const GalleryPage = lazy(() => import('../pages/Gallery'))

export const appRoutes: RoutesProps[] = [
  {
    path: '/',
    name: 'skincare-home',
    element: <Skincare />,
  },
  {
    path: '/services',
    name: 'services',
    element: <Services />,
  },
  {
    path: '/service/:id',
    name: 'service-details',
    element: <ServiceDetails />,
  },
  {
    path: '/contact',
    name: 'contact',
    element: <Contact />,
  },
  {
    path: '/about',
    name: 'about',
    element: <About />,
  },
  {
    path: '/gallery',
    name: 'gallery',
    element: <GalleryPage />,
  },
]
